import { Box, CssBaseline, ThemeProvider, useMediaQuery } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import useStyles from "./styles";
import theme from "./theme";

import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
  RouterProvider,
  Routes,
} from "react-router-dom";
import CadastroCliente from "./pages/client/cadastro";
import LoginClient from "./pages/client/login";
import { RangeProvider } from "./pages/client/range";
import RedefinirSenhaCliente from "./pages/client/redefinirSenha";
import SolicitarRedefinirSenhaCliente from "./pages/client/solicitarRedefinirSenha";
import Cadastro from "./pages/internal/cadastro";
import Financeiro from "./pages/internal/7.0-financeiro/boletos";
import Layout from "./pages/internal/layout";
import {
  default as LayoutCadastro,
  default as LayoutCadastroCliente,
} from "./pages/internal/layoutCadastro";
import Login from "./pages/internal/login";
import Perfil from "./pages/internal/2.0-clientes";
import InternoPerfilCliente from "./pages/internal/2.0-clientes/2.6-perfil";
import HostsConfig from "./pages/internal/2.0-clientes/2.2-configuracoes";
import Servicos from "./pages/internal/2.0-clientes/2.1-servicos";
import RedefinirSenha from "./pages/internal/redefinirSenha";
import SolicitarRedefinirSenha from "./pages/internal/solicitarRedefinirSenha";

//import Auditoria from "./pages/internal/administracao/auditoria";
//import RegistroLogin from "./pages/internal/administracao/registroLogin";

import RelatorioAtaquePdfEmail from "./components/relatorioAtaquePdfVersaoEmail";
import RelatorioOnuPdfEmail from "./components/relatorioOnuPdfVersaoEmail";
import RelatorioRfoPdfEmail from "./components/relatorioRfoPdfVersaoEmail";
import RelatorioDisponibilidadePdfEmail from "./components/availabilityReportPdfVersaoEmail";
import PainelDeLogs from "./pages/internal/11.0-administracao/11.2-auditoria";
import HeaderReport from "./pages/internal/11.0-administracao/11.4-geral/relatorio";
/* import EasyFlow from "./pages/internal/configuracoes/easyFlow"; */
import ResumoPercentil from "./pages/internal/overview";
import ClientRoute from "./routes/clientes";
/* import Contratos from "./pages/internal/administracao/contratos"; */
import DashAvailability from "./pages/internal/3.0-dashboard/3.3-disponibilidade";
import DashHealth from "./pages/internal/3.0-dashboard/3.2-saude";
import DashOverview from "./pages/internal/3.0-dashboard/3.1-overview";
import ProtectedRouteAdm from "./pages/internal/protectedRoute/InternoAdmRoute";
import ProtectedRoutePermission, {
  checkIsPermission,
} from "./pages/internal/protectedRoute/InternoPermissionRoute";

import { ErrorBoundary } from "react-error-boundary";
import ErrorPage from "./components/artsPersonComponent/errorPage";
import ErrorPageConnection from "./components/artsPersonComponent/errorPageConnection";

import IntergracaoErp from "./pages/internal/11.0-administracao/11.3-integracaoErp";
import Permissoes from "./pages/internal/11.0-administracao/11.4-geral/permissoes";
import PingIcons from "./pages/internal/11.0-administracao/11.4-geral/pingIcons";
import DashSfp from "./pages/internal/3.0-dashboard/3.5-transceptor";
import Contratos from "./pages/internal/7.0-financeiro/contratos";
import LayoutDashboard from "./pages/internal/3.0-dashboard";
import FormCircuito from "./pages/internal/2.0-clientes/2.3-circuito";
import RelatorioWith from "./pages/internal/5.0-relatorioWith";
//import PageRelatorios from "./pages/internal/relatorios";
import Tickets from "./pages/internal/6.0-suporte/tickets";
import Usuarios from "./pages/internal/11.0-administracao/11.1-usuarios";
import Atendimentos from "./pages/internal/6.0-suporte/atendimentos";
import DashOnu from "./pages/internal/3.0-dashboard/3.6-onu";
import OsFluxo from "./pages/internal/6.0-suporte/osFluxo";
import Os from "./pages/internal/6.0-suporte/os";
import DashAtendimentos from "./pages/internal/6.0-suporte/dashAtendimentos";
import BlocosEasyFlow from "./pages/internal/2.0-clientes/2.5-flow";
import EasyFlow from "./pages/internal/3.0-dashboard/3.8-flow";
import DashBgp from "./pages/internal/3.0-dashboard/3.7-linksEsessoes";
import CadastroHosts from "./pages/internal/8.0-cadastroHosts";
import RemoteAccess from "./pages/internal/2.0-clientes/2.4-acessoRemoto";
import CadastroTable from "./pages/internal/8.0-cadastroHosts/cadastro";
import Geral from "./pages/internal/11.0-administracao/11.4-geral";
import Suporte from "./pages/internal/11.0-administracao/11.4-geral/suporte";
import ClientesSwap from "./pages/internal/9.0-clientesSwap";
import AllReports from "./pages/internal/4.0-relatorios/componentes/allReports";
import RelatorioView from "./pages/internal/4.0-relatorios";
import DashFirewall from "./pages/internal/3.0-dashboard/3.4-firewall";
import WorkSpace from "./pages/internal/workSpace";
import MacrosGlobais from "./pages/internal/11.0-administracao/11.4-geral/macrosGlobais";
import CentralDeAlertas from "./pages/internal/10.0-centralDeAlertas";
import CentralDeAlertasConfig from "./pages/internal/10.0-centralDeAlertas/config";
import ConfigFlow from "./pages/internal/11.0-administracao/11.4-geral/configFlow";
import Clientes from "./pages/internal/11.0-administracao/11.4-geral/clientes";

function App() {
  //Modo dark setado no localStorage
  const themeLocalSotarege = localStorage.getItem("darkMode");
  const erp = window?.config?.REACT_APP_ERP || process.env.REACT_APP_ERP;
  //Conversao para boolean
  const boleandThemeLocalStorage =
    themeLocalSotarege !== null && themeLocalSotarege !== undefined
      ? JSON.parse(themeLocalSotarege)
      : null;

  //Preferencia caso nao tenha no localStorage
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");

  const [colorMode, setColorMode] = useState(
    boleandThemeLocalStorage !== null
      ? boleandThemeLocalStorage
      : prefersDarkMode,
  );

  const [contratoVencimento, setContratoVencimento] = useState(false);
  const [admPermissao, setAdmPermissao] = useState(false);
  const [routesPermissao, setRoutesPermissao] = useState([]);

  const styles = useStyles(colorMode);
  const myTheme = useMemo(() => theme(colorMode), [colorMode]);

  useEffect(() => {
    // Criamos uma função interna assíncrona
    const initializeUser = async () => {
      try {
        const data = localStorage.getItem("user");
        if (data) {
          const result = JSON.parse(data);

          // Agora você pode usar await com segurança
          const userPermission = await checkIsPermission();

          setAdmPermissao(userPermission?.isAdmin);

          setRoutesPermissao(formatObjectPermissoes(result?.usuario));
        }
      } catch (error) {
        console.error("Erro ao carregar permissões:", error);
      }
    };

    initializeUser();
  }, []); // Executa apenas uma vez ao montar

  const buildTreePermissao = (dadosUsuario) => {
    // 1. Extrair todas as visualizações de todas as permissões em um único array plano
    const todasVisualizacoes = dadosUsuario.flatMap(
      (p) => p.permissao.permissoesVisualizacao,
    );

    // 2. Função recursiva para construir a árvore
    const construir = (parentId = null) => {
      return (
        todasVisualizacoes
          .filter((item) => item.parentId === parentId)
          .map((item) => ({
            ...item,
            // Chamada recursiva: busca itens cujo parentId seja o ID do item atual
            children: construir(item.id),
          }))
          // Ordena pela propriedade 'posicao' para garantir a ordem correta na UI
          .sort((a, b) => a.posicao - b.posicao)
      );
    };

    return construir(null);
  };
  const formatObjectPermissoes = (dadosUsuario) => {
    // 1. Achatamos todas as visualizações em um único array plano
    const todasVisualizacoes = dadosUsuario.rlPermissoesUsuario.flatMap(
      (item) => item.permissao.permissoesVisualizacao,
    );

    // 2. Transformamos o array em um único objeto usando reduce
    return todasVisualizacoes.reduce((acc, viz) => {
      if (!viz?.path) {
        return false;
      }
      acc[viz.path] = true;
      return acc;
    }, {});
  };

  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route
        path="*"
        element={
          <ThemeProvider theme={myTheme}>
            <CssBaseline />
            <Box
              className="App"
              sx={{
                backgroundColor: "background.wallpaper",
                minHeight: "100vh",
              }}
            >
              <RangeProvider>
                <ErrorBoundary
                  FallbackComponent={({ error, resetErrorBoundary }) => (
                    <ErrorPage
                      error={error}
                      resetErrorBoundary={resetErrorBoundary}
                      gradientDark={myTheme.palette.buttonHoverGradient.dark}
                      gradientLight={myTheme.palette.buttonHoverGradient.light}
                      backgroundColor={myTheme.palette.background.wallpaper}
                      paperErrorPage={myTheme.palette.paperErrorPage.main}
                    />
                  )}
                >
                  <Routes>
                    <Route
                      path="*"
                      element={
                        <Navigate
                          replace
                          to="/login"
                          state={{
                            from: window.location.pathname,
                            trace: "Fallback hit in App.js",
                          }}
                        />
                      }
                    />

                    <Route
                      path="/interno/*"
                      element={<Navigate replace to="/interno/login" />}
                    />
                    <Route exact path="/login" element={<LoginClient />} />
                    <Route
                      exact
                      path="/interno/login"
                      element={
                        <Login
                          setAdmPermissao={setAdmPermissao}
                          setRoutesPermissao={setRoutesPermissao}
                          buildTreePermissao={buildTreePermissao}
                          checkIsPermission={checkIsPermission}
                          formatObjectPermissoes={formatObjectPermissoes}
                        />
                      }
                    />
                    <Route
                      element={
                        <LayoutCadastroCliente
                          colorMode={colorMode}
                          setColorMode={setColorMode}
                        />
                      }
                    >
                      <Route
                        path="/cliente/cadastro"
                        element={<CadastroCliente />}
                      />

                      <Route
                        exact
                        path="/cliente/redefinirSenha"
                        element={<SolicitarRedefinirSenhaCliente />}
                      />
                      <Route
                        exact
                        path="/cliente/redefinirSenha/:token/:id"
                        element={<RedefinirSenhaCliente />}
                      />
                    </Route>

                    <Route
                      element={
                        <LayoutCadastro
                          colorMode={colorMode}
                          setColorMode={setColorMode}
                        />
                      }
                    >
                      <Route
                        path="/interno/cadastro"
                        element={
                          <Cadastro
                            setAdmPermissao={setAdmPermissao}
                            setRoutesPermissao={setRoutesPermissao}
                            buildTreePermissao={buildTreePermissao}
                            checkIsPermission={checkIsPermission}
                            formatObjectPermissoes={formatObjectPermissoes}
                          />
                        }
                      />

                      <Route
                        exact
                        path="/interno/redefinirSenha"
                        element={<SolicitarRedefinirSenha />}
                      />
                      <Route
                        exact
                        path="/interno/redefinirSenha/:token/:id"
                        element={<RedefinirSenha />}
                      />
                    </Route>

                    <Route
                      element={
                        <Layout
                          colorMode={colorMode}
                          setColorMode={setColorMode}
                          routesPermissao={routesPermissao}
                          admPermissao={admPermissao}
                        />
                      }
                    >
                      <Route
                        element={
                          <ProtectedRoutePermission
                            setAdmPermissao={setAdmPermissao}
                          />
                        }
                      >
                        <Route
                          path="/interno/dash"
                          element={
                            <LayoutDashboard
                              colorMode={colorMode}
                              setColorMode={setColorMode}
                              setContratoVencimento={setContratoVencimento}
                              contratoVencimento={contratoVencimento}
                            />
                          }
                        >
                          <Route
                            path="/interno/dash/overview"
                            element={
                              <ErrorBoundary
                                FallbackComponent={({
                                  error,
                                  resetErrorBoundary,
                                }) => (
                                  <ErrorPageConnection
                                    error={error}
                                    resetErrorBoundary={resetErrorBoundary}
                                  />
                                )}
                                resetKeys={["/interno/dash/overview"]}
                              >
                                <DashOverview />
                              </ErrorBoundary>
                            }
                          />
                          <Route
                            path="/interno/dash/saude"
                            element={
                              <ErrorBoundary
                                FallbackComponent={({
                                  error,
                                  resetErrorBoundary,
                                }) => (
                                  <ErrorPageConnection
                                    error={error}
                                    resetErrorBoundary={resetErrorBoundary}
                                  />
                                )}
                                resetKeys={["/interno/dash/saude"]}
                              >
                                <DashHealth />
                              </ErrorBoundary>
                            }
                          />
                          <Route
                            path="/interno/dash/disponibilidade"
                            element={
                              <ErrorBoundary
                                FallbackComponent={({
                                  error,
                                  resetErrorBoundary,
                                }) => (
                                  <ErrorPageConnection
                                    error={error}
                                    resetErrorBoundary={resetErrorBoundary}
                                  />
                                )}
                                resetKeys={["/interno/dash/disponibilidade"]}
                              >
                                <DashAvailability />
                              </ErrorBoundary>
                            }
                          />

                          <Route
                            path="/interno/dash/sfp"
                            element={
                              <ErrorBoundary
                                FallbackComponent={({
                                  error,
                                  resetErrorBoundary,
                                }) => (
                                  <ErrorPageConnection
                                    error={error}
                                    resetErrorBoundary={resetErrorBoundary}
                                  />
                                )}
                                resetKeys={["/interno/dash/sfp"]}
                              >
                                <DashSfp />
                              </ErrorBoundary>
                            }
                          />
                          <Route
                            path="/interno/dash/onu"
                            element={
                              <ErrorBoundary
                                FallbackComponent={({
                                  error,
                                  resetErrorBoundary,
                                }) => (
                                  <ErrorPageConnection
                                    error={error}
                                    resetErrorBoundary={resetErrorBoundary}
                                  />
                                )}
                                resetKeys={["/interno/dash/onu"]}
                              >
                                <DashOnu />
                              </ErrorBoundary>
                            }
                          />
                          <Route
                            path="/interno/dash/bgp"
                            element={
                              <ErrorBoundary
                                FallbackComponent={({
                                  error,
                                  resetErrorBoundary,
                                }) => (
                                  <ErrorPageConnection
                                    error={error}
                                    resetErrorBoundary={resetErrorBoundary}
                                  />
                                )}
                                resetKeys={["/interno/dash/bgp"]}
                              >
                                <DashBgp />
                              </ErrorBoundary>
                            }
                          />

                          <Route
                            path="/interno/dash/flow"
                            element={
                              <ErrorBoundary
                                FallbackComponent={({
                                  error,
                                  resetErrorBoundary,
                                }) => (
                                  <ErrorPageConnection
                                    error={error}
                                    resetErrorBoundary={resetErrorBoundary}
                                  />
                                )}
                                resetKeys={["/interno/dash/flow"]}
                              >
                                <EasyFlow />
                              </ErrorBoundary>
                            }
                          />
                          <Route
                            path="/interno/dash/firewall"
                            element={
                              <ErrorBoundary
                                FallbackComponent={({
                                  error,
                                  resetErrorBoundary,
                                }) => (
                                  <ErrorPageConnection
                                    error={error}
                                    resetErrorBoundary={resetErrorBoundary}
                                  />
                                )}
                                resetKeys={["/interno/dash/firewall"]}
                              >
                                <DashFirewall />
                              </ErrorBoundary>
                            }
                          />
                        </Route>

                        <Route
                          path="/interno/home/perfil"
                          element={
                            <ErrorBoundary
                              FallbackComponent={({
                                error,
                                resetErrorBoundary,
                              }) => (
                                <ErrorPageConnection
                                  error={error}
                                  resetErrorBoundary={resetErrorBoundary}
                                />
                              )}
                              resetKeys={["/interno/home/perfil"]}
                            >
                              <Perfil
                                routesPermissao={routesPermissao}
                                admPermissao={admPermissao}
                              />
                            </ErrorBoundary>
                          }
                        >
                          {" "}
                          <Route
                            path="/interno/home/perfil/servicos/:serviceId/:id"
                            element={<Servicos />}
                          />
                          <Route
                            path="/interno/home/perfil/servicos/:id"
                            element={<Servicos />}
                          />
                          <Route
                            path="/interno/home/perfil/:id"
                            element={<InternoPerfilCliente />}
                          />
                          <Route
                            path="/interno/home/perfil/config/:serviceId/:id"
                            element={<HostsConfig />}
                          />
                          <Route
                            path="/interno/home/perfil/config/:id"
                            element={<HostsConfig />}
                          />
                          <Route
                            path="/interno/home/perfil/circuito/:serviceId/:id"
                            element={<FormCircuito />}
                          />
                          <Route
                            path="/interno/home/perfil/circuito/:id"
                            element={<FormCircuito />}
                          />
                          <Route
                            path="/interno/home/perfil/flow/:id"
                            element={<BlocosEasyFlow />}
                          />
                          <Route
                            path="/interno/home/perfil/remoteAccess/:serviceId/:id"
                            element={<RemoteAccess />}
                          />
                          <Route
                            path="/interno/home/perfil/remoteAccess/:id"
                            element={<RemoteAccess />}
                          />
                        </Route>

                        <Route
                          path="/interno/relatorio"
                          element={
                            <ErrorBoundary
                              FallbackComponent={({
                                error,
                                resetErrorBoundary,
                              }) => (
                                <ErrorPageConnection
                                  error={error}
                                  resetErrorBoundary={resetErrorBoundary}
                                />
                              )}
                              resetKeys={["/interno/relatorio"]}
                            >
                              <RelatorioView />
                            </ErrorBoundary>
                          }
                        ></Route>

                        <Route
                          path="/interno/relatorio-reincidencia/*"
                          element={
                            <ErrorBoundary
                              FallbackComponent={({
                                error,
                                resetErrorBoundary,
                              }) => (
                                <ErrorPageConnection
                                  error={error}
                                  resetErrorBoundary={resetErrorBoundary}
                                />
                              )}
                              resetKeys={["/interno/relatorio-reincidencia"]}
                            >
                              <RelatorioWith />
                            </ErrorBoundary>
                          }
                        />

                        <Route
                          element={
                            <ProtectedRoutePermission permissionPath="/interno/clientesSwap" />
                          }
                        >
                          <Route
                            path="/interno/clientesSwap/:id?"
                            element={
                              <ErrorBoundary
                                FallbackComponent={({
                                  error,
                                  resetErrorBoundary,
                                }) => (
                                  <ErrorPageConnection
                                    error={error}
                                    resetErrorBoundary={resetErrorBoundary}
                                  />
                                )}
                                resetKeys={["/interno/clientesSwap"]}
                              >
                                <ClientesSwap />
                              </ErrorBoundary>
                            }
                          ></Route>
                        </Route>

                        <Route
                          path="/interno/cadastroHosts"
                          element={
                            <ErrorBoundary
                              FallbackComponent={({
                                error,
                                resetErrorBoundary,
                              }) => (
                                <ErrorPageConnection
                                  error={error}
                                  resetErrorBoundary={resetErrorBoundary}
                                />
                              )}
                              resetKeys={["/interno/cadastroHosts"]}
                            >
                              <CadastroHosts />
                            </ErrorBoundary>
                          }
                        >
                          {/* Quando a URL for exatamente /interno/cadastroHosts */}
                          <Route
                            index
                            element={<Navigate to="cadastrados" replace />}
                          />

                          <Route
                            path="cadastrados"
                            element={<CadastroTable />}
                          />
                        </Route>

                        <Route path="/interno/suporte">
                          {(erp === "HUBSOFT" || erp === "IXC") && (
                            <Route
                              path="/interno/suporte/dashAtendimentos"
                              element={
                                <ErrorBoundary
                                  FallbackComponent={({
                                    error,
                                    resetErrorBoundary,
                                  }) => (
                                    <ErrorPageConnection
                                      error={error}
                                      resetErrorBoundary={resetErrorBoundary}
                                    />
                                  )}
                                  resetKeys={[
                                    "/interno/suporte/dashAtendimentos",
                                  ]}
                                >
                                  <DashAtendimentos />
                                </ErrorBoundary>
                              }
                            />
                          )}
                          {erp === "IXC" && (
                            <>
                              <Route
                                path="/interno/suporte/fluxoOs"
                                element={
                                  <ErrorBoundary
                                    FallbackComponent={({
                                      error,
                                      resetErrorBoundary,
                                    }) => (
                                      <ErrorPageConnection
                                        error={error}
                                        resetErrorBoundary={resetErrorBoundary}
                                      />
                                    )}
                                    resetKeys={["/interno/suporte/fluxoOs"]}
                                  >
                                    <OsFluxo />
                                  </ErrorBoundary>
                                }
                              />

                              <Route
                                path="/interno/suporte/os"
                                element={
                                  <ErrorBoundary
                                    FallbackComponent={({
                                      error,
                                      resetErrorBoundary,
                                    }) => (
                                      <ErrorPageConnection
                                        error={error}
                                        resetErrorBoundary={resetErrorBoundary}
                                      />
                                    )}
                                    resetKeys={["/interno/suporte/os"]}
                                  >
                                    <Os />
                                  </ErrorBoundary>
                                }
                              />
                            </>
                          )}

                          <Route
                            path="/interno/suporte/atendimentos"
                            element={
                              <ErrorBoundary
                                FallbackComponent={({
                                  error,
                                  resetErrorBoundary,
                                }) => (
                                  <ErrorPageConnection
                                    error={error}
                                    resetErrorBoundary={resetErrorBoundary}
                                  />
                                )}
                                resetKeys={["/interno/suporte/atendimentos"]}
                              >
                                <Atendimentos />
                              </ErrorBoundary>
                            }
                          />

                          <Route
                            path="/interno/suporte/tickets"
                            element={
                              <ErrorBoundary
                                FallbackComponent={({
                                  error,
                                  resetErrorBoundary,
                                }) => (
                                  <ErrorPageConnection
                                    error={error}
                                    resetErrorBoundary={resetErrorBoundary}
                                  />
                                )}
                                resetKeys={["/interno/suporte/tickets"]}
                              >
                                <Tickets />
                              </ErrorBoundary>
                            }
                          />
                          {erp === "HUBSOFT" && (
                            <Route
                              path="/interno/suporte/workSpace"
                              element={
                                <ErrorBoundary
                                  FallbackComponent={({
                                    error,
                                    resetErrorBoundary,
                                  }) => (
                                    <ErrorPageConnection
                                      error={error}
                                      resetErrorBoundary={resetErrorBoundary}
                                    />
                                  )}
                                  resetKeys={["/interno/suporte/meu-espaco"]}
                                >
                                  <WorkSpace />
                                </ErrorBoundary>
                              }
                            />
                          )}
                        </Route>

                        <Route
                          path="/interno/centralDeAlertas"
                          element={
                            <ErrorBoundary
                              FallbackComponent={({
                                error,
                                resetErrorBoundary,
                              }) => (
                                <ErrorPageConnection
                                  error={error}
                                  resetErrorBoundary={resetErrorBoundary}
                                />
                              )}
                              resetKeys={["/interno/centralDeAlertas"]}
                            >
                              <CentralDeAlertas />
                            </ErrorBoundary>
                          }
                        />

                        <Route
                          path="/interno/centralDeAlertas/config/:aba?"
                          element={
                            <ErrorBoundary
                              FallbackComponent={({
                                error,
                                resetErrorBoundary,
                              }) => (
                                <ErrorPageConnection
                                  error={error}
                                  resetErrorBoundary={resetErrorBoundary}
                                />
                              )}
                              resetKeys={["/interno/centralDeAlertas/config"]}
                            >
                              <CentralDeAlertasConfig />
                            </ErrorBoundary>
                          }
                        />

                        <Route path="/interno/financeiro">
                          <Route
                            path="/interno/financeiro/contratos"
                            element={
                              <ErrorBoundary
                                FallbackComponent={({
                                  error,
                                  resetErrorBoundary,
                                }) => (
                                  <ErrorPageConnection
                                    error={error}
                                    resetErrorBoundary={resetErrorBoundary}
                                  />
                                )}
                                resetKeys={["/interno/financeiro/contratos"]}
                              >
                                <Contratos />
                              </ErrorBoundary>
                            }
                          />

                          <Route
                            path="/interno/financeiro/boletos"
                            element={
                              <ErrorBoundary
                                FallbackComponent={({
                                  error,
                                  resetErrorBoundary,
                                }) => (
                                  <ErrorPageConnection
                                    error={error}
                                    resetErrorBoundary={resetErrorBoundary}
                                  />
                                )}
                                resetKeys={["/interno/financeiro/boletos"]}
                              >
                                <Financeiro />
                              </ErrorBoundary>
                            }
                          />
                        </Route>

                        {/* Rota de administração possui o ProtectedRouteAdm */}
                        <Route
                          path="/interno/administracao"
                          element={<ProtectedRouteAdm />}
                        >
                          <Route
                            path="/interno/administracao/usuarios"
                            element={
                              <ErrorBoundary
                                FallbackComponent={({
                                  error,
                                  resetErrorBoundary,
                                }) => (
                                  <ErrorPageConnection
                                    error={error}
                                    resetErrorBoundary={resetErrorBoundary}
                                  />
                                )}
                                resetKeys={["/interno/administracao/usuarios"]}
                              >
                                <Usuarios />
                              </ErrorBoundary>
                            }
                          />

                          <Route
                            path="/interno/administracao/auditoria"
                            element={
                              <ErrorBoundary
                                FallbackComponent={({
                                  error,
                                  resetErrorBoundary,
                                }) => (
                                  <ErrorPageConnection
                                    error={error}
                                    resetErrorBoundary={resetErrorBoundary}
                                  />
                                )}
                                resetKeys={["/interno/administracao/auditoria"]}
                              >
                                <PainelDeLogs />
                              </ErrorBoundary>
                            }
                          ></Route>

                          <Route
                            path="/interno/administracao/integracaoErp"
                            element={
                              <ErrorBoundary
                                FallbackComponent={({
                                  error,
                                  resetErrorBoundary,
                                }) => (
                                  <ErrorPageConnection
                                    error={error}
                                    resetErrorBoundary={resetErrorBoundary}
                                  />
                                )}
                                resetKeys={[
                                  "/interno/administracao/integracaoErp",
                                ]}
                              >
                                <IntergracaoErp />
                              </ErrorBoundary>
                            }
                          />

                          {/* ###########################################33 */}
                          <Route
                            path="/interno/administracao/geral"
                            element={
                              <ErrorBoundary
                                FallbackComponent={({
                                  error,
                                  resetErrorBoundary,
                                }) => (
                                  <ErrorPageConnection
                                    error={error}
                                    resetErrorBoundary={resetErrorBoundary}
                                  />
                                )}
                                resetKeys={["/interno/administracao/geral"]}
                              >
                                <Geral />
                              </ErrorBoundary>
                            }
                          >
                            <Route
                              path="/interno/administracao/geral/relatorio"
                              element={<HeaderReport />}
                            />
                            <Route
                              path="/interno/administracao/geral/clientes"
                              element={<Clientes />}
                            />
                            <Route
                              path="/interno/administracao/geral/suporte"
                              element={<Suporte />}
                            />
                            <Route
                              path="/interno/administracao/geral/permissoes"
                              element={<Permissoes />}
                            />
                            <Route
                              path="/interno/administracao/geral/pingIcons"
                              element={<PingIcons />}
                            />
                            <Route
                              path="/interno/administracao/geral/macrosGlobais"
                              element={<MacrosGlobais />}
                            />
                            <Route
                              path="/interno/administracao/geral/flow"
                              element={<ConfigFlow />}
                            />
                          </Route>

                          {/* ###########################################33 */}
                        </Route>

                        <Route
                          path="/interno/resumo"
                          element={
                            <ErrorBoundary
                              FallbackComponent={({
                                error,
                                resetErrorBoundary,
                              }) => (
                                <ErrorPageConnection
                                  error={error}
                                  resetErrorBoundary={resetErrorBoundary}
                                />
                              )}
                              resetKeys={["/interno/resumo"]}
                            >
                              <ResumoPercentil />
                            </ErrorBoundary>
                          }
                        />
                      </Route>
                    </Route>

                    {ClientRoute({
                      pathName: "",
                      colorMode: { colorMode },
                      setColorMode,
                    })}
                    <Route path="/mirror">
                      {ClientRoute({
                        pathName: "/mirror",
                        colorMode: { colorMode },
                        setColorMode,
                      })}
                    </Route>
                    <Route
                      path="/agendamentos/relatorioAtaque/gerar"
                      element={<RelatorioAtaquePdfEmail />}
                    />
                    <Route
                      path="/agendamentos/relatorioOnu/gerar"
                      element={<RelatorioOnuPdfEmail />}
                    />
                    <Route
                      path="/agendamentos/relatorioRfo/gerar"
                      element={<RelatorioRfoPdfEmail />}
                    />
                    <Route
                      path="/agendamentos/relatorioDisponibilidade/gerar"
                      element={<RelatorioDisponibilidadePdfEmail />}
                    />
                  </Routes>
                </ErrorBoundary>
              </RangeProvider>
            </Box>
          </ThemeProvider>
        }
      />,
    ),
  );

  return <RouterProvider router={router} />;
}

export default App;
